




































































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { ImportacaoDeNota, ProdutoDaImportacao } from '@/models/ImportacaoDeNota'
import { FindProdutoUseCase } from '@/usecases/produto/FindProdutoUseCase'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import {
	ehComVariantes,
	atributoDaVariante,
	somaDistribuida,
	saldoDoItem,
	distribuirIgualmente,
} from '@/usecases/importacao-de-notas/importacaoHelpers'

/**
 * Etapa 3 — distribuição de quantidade entre variantes (nota fechada na referência).
 * Para cada item "Com Variantes": carrega a grade, mostra saldo em tempo real e
 * preenche variante.quantidadeImportacao (consumido pelo backend v2).
 */
@Component
export default class EtapaQuantidades extends Vue {
	@Prop({ type: Object, default: null }) importacao!: ImportacaoDeNota | null

	carregando = false
	private findProduto = new FindProdutoUseCase()

	get itens(): ProdutoDaImportacao[] {
		return this.importacao ? this.importacao.produtos.filter(ehComVariantes) : []
	}

	async mounted() {
		await this.carregarVariantes()
	}

	async carregarVariantes() {
		const pendentes = this.itens.filter(p => {
			const vs = (p.encontrado as any).variantes
			return !vs || vs.length === 0
		})
		if (pendentes.length === 0) return

		try {
			this.carregando = true
			await Promise.all(pendentes.map(async p => {
				const enc: any = p.encontrado
				if (!enc || !enc.id) return
				const variantes = await this.findProduto.buscarVariantes(enc.id)
				if (variantes) {
					variantes.forEach((v: any) => { if (v.quantidadeImportacao == null) v.quantidadeImportacao = 0 })
					this.$set(enc, 'variantes', variantes)
				}
			}))
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	atributo(v: any, nome: string): string {
		return atributoDaVariante(v, nome)
	}

	distribuido(item: ProdutoDaImportacao): number {
		return somaDistribuida(item)
	}

	total(item: ProdutoDaImportacao): number {
		return Math.trunc(Number(item.nota.qCom) || 0)
	}

	saldo(item: ProdutoDaImportacao): number {
		return saldoDoItem(item)
	}

	distribuir(item: ProdutoDaImportacao) {
		distribuirIgualmente(item)
		const enc: any = item.encontrado
		this.$set(enc, 'variantes', [...enc.variantes])
	}

	tocar() {
		// força reavaliação dos computeds de saldo ao digitar
		this.$forceUpdate()
	}
}
